import React, { useState, useEffect } from 'react';
import { Radio, Button, Input } from 'antd'; // Make sure Input is imported if needed
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';

const MilestoneGroupContent = ({ selectedGroup, setSelectedGroup }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isClearVisible, setIsClearVisible] = useState(false);
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);

  // Define the attributes with their isDate flag
  const allMilestoneAttributes = [
    { key: 'None', label: 'None' },
    { key: 'milestoneNumber', label: '#', group: 'General' },
    { key: 'name', label: 'Name', group: 'General' },
    { key: '# - Name', label: '# - Name', group: 'General' },
    { key: 'Owner', label: 'Milestone owner', group: 'General' },
    { key: 'Milestone Status', label: 'Status', group: 'General' },
    { key: 'type', label: 'Type', group: 'General' },
    { key: 'Work starting date', label: 'Work starting date', group: 'Dates', isDate: true },
    { key: 'Milestone completion date', label: 'Milestone completion date', group: 'Dates', isDate: true },
    { key: 'Change in Milestone completion date (binned, current vs last week)', label: 'Change in Milestone completion date (binned, current vs last week)', group: 'Dates' },
    { key: 'Planning summary (simplified)', label: 'Planning summary (simplified)', group: 'Dates' },
    { key: 'Milestone Planning Summary', label: 'Planning summary', group: 'Dates' },
    { key: '(LW) Planning summary', label: '(LW) Planning summary', group: 'Dates' },
    { key: 'planningCheck', label: 'Planning check', group: 'Dates' },
    { key: 'Created On', label: 'Created on', group: 'Dates', isDate: true },
    { key: 'Created by', label: 'Created by', group: 'Dates' },
    { key: 'Updated On', label: 'Updated on', group: 'Dates', isDate: true },
    { key: 'Updated by', label: 'Updated by', group: 'Dates' },
  ];

  // Group attributes for rendering
  const groupedAttributes = allMilestoneAttributes.reduce((acc, attr) => {
    const groupName = attr.group || 'Other';
    if (!acc[groupName]) {
      acc[groupName] = [];
    }
    acc[groupName].push(attr);
    return acc;
  }, {});

  // Handler for the main group selection
  const handleMainGroupChange = (e) => {
    const newGroup = e.target.value;
    setSelectedGroup(newGroup);

    // Reset nested filter if a non-date item is selected
    const isDateKey = allMilestoneAttributes.find(attr => attr.key === newGroup)?.isDate;
    if (!isDateKey) {
      setSelectedDateFilter(null);
    }
  };

  const handleDateFilterChange = (e) => {
    const newDateFilter = e.target.value;
    setSelectedDateFilter(newDateFilter);
    // Combine the main key and the date filter for the final state
    setSelectedGroup(`${selectedGroup.split('_')[0]}_${newDateFilter}`);
  };

  const handleClear = () => {
    setSelectedGroup('None');
    setSelectedDateFilter(null);
  };

  useEffect(() => {
    setIsClearVisible(selectedGroup !== 'None' && selectedGroup !== null);
  }, [selectedGroup]);

  // Determine the key for the current main group selection
  const selectedMainKey = selectedGroup?.includes('_') ? selectedGroup.split('_')[0] : selectedGroup;

  return (
    <div style={{ padding: '10px', maxHeight: '500px', overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <Input
          placeholder="Search attributes..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ marginRight: '8px', flex: 1 }}
          prefix={<SearchOutlined />}
        />
        {isClearVisible && (
          <Button
            type="text"
            onClick={handleClear}
            style={{ padding: 0, color: 'blue' }}
            icon={<CloseCircleOutlined />}
          >
            Clear
          </Button>
        )}
      </div>
      <Radio.Group onChange={handleMainGroupChange} value={selectedMainKey}>
        {Object.entries(groupedAttributes).map(([groupName, attributes]) => (
          <div key={groupName}>
            <div style={{ fontWeight: 'bold', marginTop: '10px', fontSize: 14, color: '#333' }}>
              {groupName}
            </div>
            {attributes.map((attr) => (
              <div key={attr.key}>
                <Radio value={attr.key} style={{ display: 'block' }}>
                  {attr.label}
                </Radio>
                {attr.isDate && selectedMainKey === attr.key && (
                  <div style={{ paddingLeft: '20px', marginTop: '5px' }}>
                    <Radio.Group onChange={handleDateFilterChange} value={selectedDateFilter}>
                      <Radio value="Year" style={{ display: 'block' }}>Year</Radio>
                      <Radio value="Quarter" style={{ display: 'block' }}>Quarter</Radio>
                      <Radio value="Month" style={{ display: 'block' }}>Month</Radio>
                      <Radio value="Week" style={{ display: 'block' }}>Week</Radio>
                      <Radio value="Day" style={{ display: 'block' }}>Day</Radio>
                    </Radio.Group>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </Radio.Group>
    </div>
  );
};

export default MilestoneGroupContent;